<ion-card>
  <ion-card-header>
    <ion-card-title>Tanuló kiléptetése</ion-card-title>
    <ion-card-subtitle>Távozás az iskolából — a besorolások lezárásával és a mulasztási kimutatással</ion-card-subtitle>
  </ion-card-header>

  <ion-card-content>
    <ion-note color="medium" class="ki-bevezeto">
      Ha a tanuló elmegy, két dolgot kell elintézni. A <b>besorolásait le kell zárni</b>,
      különben ott marad az osztály névsorában és a csoportjaiban: tovább jelölik
      hiányzónak, és a szülői felületen tovább fut az órarendje. A <b>mulasztásait pedig
      ki kell tudni íratni</b>, mert a hivatalos napló az e-KRÉTA — ami nálunk összegyűlt,
      azt oda kell átvezetni.
      <br><b>Nem törlünk semmit:</b> a jogviszony és a csoporttagság csak záró dátumot kap,
      a jegyek, a hiányzások és a feljegyzések változatlanul megmaradnak.
    </ion-note>

    <div class="ki-allapot hiba" *ngIf="hiba">
      <ion-icon name="alert-circle-outline"></ion-icon><span>{{ hiba }}</span>
    </div>

    <!-- 1. Tanuló -->
    <div class="ki-lepes">
      <h3><span class="ki-szam">1</span> Ki megy el?</h3>
      <ion-input label="Tanuló keresése" label-placement="stacked" fill="outline"
                 placeholder="név, oktatási azonosító vagy osztály"
                 [(ngModel)]="tanuloSzuro"></ion-input>
      <div class="ki-talalatok" *ngIf="!valasztottTanulo">
        <button class="ki-talalat" *ngFor="let t of szurtTanulok" (click)="tanuloValaszt(t)">
          <b>{{ t.nev }}</b>
          <span class="ki-halvany">{{ t.oktazon }}</span>
          <span class="ki-osztaly" [class.nincs]="!t.osztaly">{{ t.osztaly || 'nincs osztálya' }}</span>
        </button>
        <div class="ki-ures" *ngIf="!szurtTanulok.length">Nincs találat.</div>
      </div>
      <div class="ki-valasztott" *ngIf="valasztottTanulo">
        <b>{{ valasztottTanulo.nev }}</b>
        <span class="ki-halvany">{{ valasztottTanulo.oktazon }}</span>
        <span class="ki-osztaly">{{ valasztottTanulo.osztaly || 'nincs osztálya' }}</span>
        <ion-button size="small" fill="clear" (click)="masikTanulo()">Másik tanuló</ion-button>
      </div>
    </div>

    <!-- 2. Mulasztási kimutatás -->
    <div class="ki-lepes" *ngIf="valasztottTanulo && elemzes">
      <h3><span class="ki-szam">2</span> Mit kell átvezetni az e-KRÉTÁ-ba?</h3>

      <div class="ki-szamok">
        <div class="ki-szamkartya">
          <b>{{ elemzes.mulasztas.osszes }}</b><span>mulasztott óra</span>
        </div>
        <div class="ki-szamkartya jo">
          <b>{{ elemzes.mulasztas.igazolt }}</b><span>igazolt</span>
        </div>
        <div class="ki-szamkartya rossz">
          <b>{{ elemzes.mulasztas.igazolatlan }}</b><span>igazolatlan</span>
        </div>
        <div class="ki-szamkartya varakozo">
          <b>{{ elemzes.mulasztas.elbiralatlan }}</b><span>még nincs elbírálva</span>
        </div>
      </div>

      <div class="ki-allapot figyelem" *ngIf="elemzes.rendezetlen">
        <ion-icon name="warning-outline"></ion-icon>
        <span>
          <b>{{ elemzes.rendezetlen }} óra még rendezetlen</b> (igazolatlan vagy elbírálatlan).
          Ha lehet, a kiléptetés ELŐTT bíráld el — így pontos állapot kerül az e-KRÉTÁ-ba.
          Az osztályfőnöki felületen tehető meg.
        </span>
      </div>

      <div class="ki-tipusok" *ngIf="tipusSorok.length">
        <span *ngFor="let t of tipusSorok"><b>{{ t.db }}</b> {{ t.nev }}</span>
      </div>

      <div class="ki-gombsor">
        <ion-button size="small" fill="outline" (click)="kimutatasLetoltes()"
                    [disabled]="!elemzes.mulasztas.osszes">
          <ion-icon slot="start" name="download-outline"></ion-icon>
          Kimutatás letöltése (CSV)
        </ion-button>
        <ion-button size="small" fill="clear" (click)="tetelekNyitva = !tetelekNyitva"
                    *ngIf="elemzes.tetelek?.length">
          {{ tetelekNyitva ? 'Tételek elrejtése' : 'Tételes lista (' + elemzes.tetelek.length + ' óra)' }}
        </ion-button>
      </div>

      <table class="ki-tabla" *ngIf="tetelekNyitva && elemzes.tetelek?.length">
        <thead>
          <tr><th>Dátum</th><th>Óra</th><th>Tantárgy</th><th>Osztály/csoport</th><th>Állapot</th></tr>
        </thead>
        <tbody>
          <tr *ngFor="let t of elemzes.tetelek">
            <td>{{ t.datum }}</td>
            <td>{{ t.ora }}.<span *ngIf="t.hossz > 1">–{{ t.ora + t.hossz - 1 }}.</span></td>
            <td>{{ t.tantargy || '—' }}</td>
            <td>{{ t.cel || '—' }}</td>
            <td [class.rossz]="t.igazolas_allapot === 'igazolatlan'"
                [class.varakozo]="t.igazolas_allapot === 'elbiralatlan'">
              <span *ngIf="t.igazolas_allapot === 'igazolt'">igazolt — {{ t.igazolas_nev }}</span>
              <span *ngIf="t.igazolas_allapot === 'igazolatlan'">igazolatlan</span>
              <span *ngIf="t.igazolas_allapot === 'elbiralatlan'">még nincs elbírálva</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 3. Mi zárul le -->
    <div class="ki-lepes" *ngIf="valasztottTanulo && elemzes">
      <h3><span class="ki-szam">3</span> Mikortól, és mi zárul le?</h3>

      <div class="ki-sor">
        <ion-input label="A távozás napja" labelPlacement="stacked" fill="outline" type="date"
                   [(ngModel)]="datum" (ionChange)="elemez()"></ion-input>
        <!-- A megszűnés oka a törvényi eset szerint (Nkt. 53. §) – a beírási napló 95. § (9) ag) rovatához. -->
        <ion-select label="A megszűnés oka" labelPlacement="stacked" fill="outline" interface="popover"
                    [(ngModel)]="okKod" placeholder="Válassz…">
          <ion-select-option [value]="''">— nincs megadva —</ion-select-option>
          <ion-select-option *ngFor="let o of okok" [value]="o.kod">{{ o.nev }}{{ o.jogalap ? ' (' + o.jogalap + ')' : '' }}</ion-select-option>
        </ion-select>
        <ion-input label="Kiegészítés (nem kötelező)" labelPlacement="stacked" fill="outline"
                   placeholder="pl. a szülő kérésére, költözés miatt" [(ngModel)]="ok"
                   maxlength="200"></ion-input>
        <ion-input label="Az új intézmény neve" labelPlacement="stacked" fill="outline"
                   placeholder="ahová felvették / átvették (OM-azonosító)" [(ngModel)]="atvevo"
                   maxlength="255"></ion-input>
      </div>
      <ion-note color="medium" class="ki-sugo">
        A megadott nap még <b>beleszámít</b>: aznap a tanuló még idejárt.
      </ion-note>

      <!-- Iskolaváltás: az átadó csomag (Nkt. 41. § (8a)) felkínálása és állapota. -->
      <div class="ki-allapot figyelem" *ngIf="iskolavaltas">
        <ion-icon [name]="elemzes.atado?.keszult ? 'checkmark-circle-outline' : 'swap-horizontal-outline'"></ion-icon>
        <span>
          <b>Iskolaváltás</b> — az új iskolának át kell adni a tanuló tantárgyankénti előrehaladását és
          (tanév közben) az évközi jegyeit (Nkt. 41. § (8a)).
          <span *ngIf="elemzes.atado?.keszult">Az átadó csomag elkészült: {{ elemzes.atado?.utolso?.mikor }}<span *ngIf="elemzes.atado?.utolso?.ki">, {{ elemzes.atado?.utolso?.ki }}</span>.</span>
          <b *ngIf="elemzes.atado && !elemzes.atado.keszult">Az átadó csomag még nem készült el.</b>
          <ion-button size="small" fill="outline" (click)="atadoNyit()">
            <ion-icon slot="start" name="document-outline"></ion-icon>Átadó csomag készítése
          </ion-button>
        </span>
      </div>

      <ul class="ki-lista">
        <li *ngFor="let j of elemzes.jogviszonyok">
          <b>{{ j.osztaly || 'osztály nélkül' }}</b>
          <span class="ki-halvany">{{ j.kezdete }}{{ j.vege ? ' – ' + j.vege : ' – nyitott' }}</span>
          <span class="ki-cimke" *ngIf="j.elo">lezárul</span>
        </li>
        <li *ngFor="let cs of elemzes.csoportok">
          {{ cs.name }}
          <span class="ki-halvany" *ngIf="cs.nem_tanorai">nem tanórai</span>
          <span class="ki-cimke">lezárul</span>
        </li>
      </ul>
      <div class="ki-ures" *ngIf="!elemzes.jogviszonyok?.length && !elemzes.csoportok?.length">
        Ennek a tanulónak nincs lezárandó besorolása.
      </div>

      <ion-item lines="none" class="ki-jelolo" *ngIf="elemzes.kilepes_utani?.length">
        <ion-checkbox slot="start" [(ngModel)]="utaniTorles"></ion-checkbox>
        <ion-label class="ion-text-wrap">
          A távozás napja <b>után</b> még {{ elemzes.kilepes_utani.length }} órán van
          hiányzónak jelölve — ezeket vegyük le.
          <div class="ki-halvany">
            Onnantól már nincs órája, tehát ez téves jelölés. A dátumig bezárólag semmihez nem nyúlunk.
          </div>
        </ion-label>
      </ion-item>
    </div>

    <!-- 4. Végrehajtás -->
    <div class="ki-lab" *ngIf="valasztottTanulo && elemzes">
      <div class="ki-osszegzo">
        <b>{{ valasztottTanulo.nev }}</b> kiléptetése {{ datum }} nappal.
        <span *ngIf="elemzes.rendezetlen" class="rossz">
          {{ elemzes.rendezetlen }} óra rendezetlenül marad.
        </span>
      </div>
      <ion-button color="primary" [disabled]="fut" (click)="vegrehajt()">
        <ion-icon slot="start" name="exit-outline"></ion-icon>
        {{ fut ? 'Kiléptetés…' : 'Kiléptetés végrehajtása' }}
      </ion-button>
    </div>
  </ion-card-content>
</ion-card>
